import { initDependencies, setupDependencies } from './app';

setupDependencies();

initDependencies();

const { runApp } = require('./services/runApp');
runApp();

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
if ((module as any).hot) {
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  (module as any).hot.accept();
}
